import { PanelRightClose } from "lucide-react";
import { ScrollArea } from "@/components/ui/scroll-area";
import { Tooltip, TooltipContent, TooltipTrigger } from "@/components/ui/tooltip";
import MiniMonthCalendar from "../mini-month-calendar";
import { SelectedDayEventDetails } from "./selected-day-event-details";

export function DayViewRightPanel({
  setRightPanelOpen,
  selectedDate,
  eventsByDate,
  onSelectDate,
  onNavigateMonth,
  selectedEvent,
  use12HourFormat,
}) {
  return (
    <aside className="flex h-full min-h-0 flex-col border-l border-border/80 bg-muted/20 shadow-[inset_1px_0_0_0_hsl(var(--border)/0.5)] md:sticky md:top-0 dark:bg-muted/20">
      <div className="sticky top-0 z-20 flex shrink-0 items-center justify-between gap-2 border-b border-border/60 bg-background/80 px-3 py-2 backdrop-blur-md supports-backdrop-filter:bg-background/70">
        <p className="text-sm font-semibold text-foreground">Details</p>
        <Tooltip>
          <TooltipTrigger asChild>
            <button
              type="button"
              className="inline-flex size-9 shrink-0 items-center justify-center rounded-lg text-muted-foreground transition-colors hover:bg-muted hover:text-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2"
              aria-expanded
              aria-controls="day-view-right-panel"
              onClick={() => setRightPanelOpen(false)}
            >
              <PanelRightClose className="size-[18px]" strokeWidth={1.5} aria-hidden />
              <span className="sr-only">Hide panel</span>
            </button>
          </TooltipTrigger>
          <TooltipContent side="left" className="text-xs">
            Hide panel
          </TooltipContent>
        </Tooltip>
      </div>
      <ScrollArea
        id="day-view-right-panel"
        className="min-h-0 flex-1 pr-2"
        role="region"
        aria-label="Calendar and event details"
      >
        <div className="space-y-6 px-7 pb-8 pt-6">
          <MiniMonthCalendar
            selectedDate={selectedDate}
            eventsByDate={eventsByDate}
            onSelectDate={onSelectDate}
            onNavigateMonth={onNavigateMonth}
          />

          <section className="space-y-3 rounded-lg border border-border bg-background p-4 shadow-sm">
            <h3 className="text-sm font-semibold text-foreground">Event details</h3>
            {selectedEvent ? (
              <SelectedDayEventDetails event={selectedEvent} use12HourFormat={use12HourFormat} />
            ) : (
              <p className="text-sm text-muted-foreground">No events for the selected day.</p>
            )}
          </section>
        </div>
      </ScrollArea>
    </aside>
  );
}
